export const GmailIcon =()=>{
    return(
        
        <a href="mailto:cs.fadesolutions@gmail.com" target="blank" >
            <svg className="w-auto h-[1.75rem]" viewBox="0 0 44 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1695_1164)">
                <path d="M3.5375 31.9999H10.3436V15.5428L0.620605 8.22852V29.0857C0.620605 30.6857 1.93607 31.9999 3.5375 31.9999Z" fill="#F4F4F4"/>
                <path d="M33.6216 31.9999H40.4277C42.0291 31.9999 43.3445 30.6857 43.3445 29.0857V8.22852L33.6216 15.4857" fill="#F4F4F4"/>
                <path d="M33.6216 2.91433V15.5429L43.3445 8.28576V4.3429C43.3445 0.742903 39.2266 -1.31424 36.3669 0.857189" fill="#FBFBFB"/>
                <path d="M10.3438 15.5429V2.91431L22.0113 11.6572L33.6217 2.91431V15.5429L21.9541 24.2286" fill="#EAEAEA"/>
                <path d="M0.620605 4.343V8.22871L10.3436 15.4859V2.91443L7.59826 0.857282C4.73857 -1.257 0.620605 0.800139 0.620605 4.343Z" fill="#DADADA"/>
                </g>
                <defs>
                <clipPath id="clip0_1695_1164">
                <rect width="42.6667" height="32" fill="white" transform="translate(0.620605)"/>
                </clipPath>
                </defs>
            </svg>
        </a>
    )
}
